import React, { useState, useEffect } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import { MdAddHome } from "react-icons/md";
import { EditHospitalDetails } from "../../../../Service/partnerAPI";
import Loader from "../../../../reusableUI/loader";

const EditHospital = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const editUser = location?.state?.editUser;
  const [hospitalData, setHospitalData] = useState(editUser || {});
  const [loading, setLoading] = useState(false);

  const caseList = [
    { label: "+91", value: "+91" },
    { label: "+1", value: "+1" },
    { label: "+44", value: "+44" },
  ];

  const caseTitle = [
    { label: "Mr.", value: "Mr." },
    { label: "Mrs.", value: "Mrs." },
    { label: "Ms.", value: "Ms." },
    { label: "Dr.", value: "Dr." },
  ];

  useEffect(() => {
    setHospitalData(editUser || {});
  }, [editUser]);

  // Update nested object by path
  const updateObject = (path, value) => {
    setHospitalData((prevData) => {
      const newData = JSON.parse(JSON.stringify(prevData));
      let current = newData;
      for (let i = 0; i < path.length - 1; i++) {
        if (!(path[i] in current)) current[path[i]] = {};
        current = current[path[i]];
      }
      current[path[path.length - 1]] = value;
      return newData;
    });
  };

  const handleChange = (path, value) => {
    updateObject(path, value);
  };

  const EditSave = async () => {
    setLoading(true);
    try {
      const res = await EditHospitalDetails(hospitalData?._id, hospitalData);
      if (res.error === false) {
        alert("Hospital updated successfully!");
        navigate("/hospital");
      } else {
        alert("Update failed. Please try again.");
      }
    } catch (error) {
      console.error("Error updating hospital:", error);
      alert("An error occurred while updating.");
    } finally {
      setLoading(false);
    }
  };

  const renderContactForm = (contact, index) => (
    <div className="w-full mb-4" key={index}>
      <div className="p-4 rounded bg-gray-50 border border-gray-300">
        <div className="flex flex-wrap justify-around items-center gap-4 w-full">
          <div className="flex-1 min-w-[120px]">
            <label className="text-[13px] text-[#606060] mb-1 block font-poppins">
              Department <span className="text-[red]">*</span>
            </label>
            <input
              type="text"
              className="border px-2 py-1 border-[#D2D2D2] rounded-sm text-[12px] font-poppins w-full"
              value={"Hospital"}
              readOnly
            />
          </div>

          <div className="flex-1 min-w-[160px]">
            <div className="flex flex-row items-center gap-10 mb-1">
              <label className="text-[13px] font-poppins text-[#606060] block">
                Title
              </label>
              <label className="text-[13px] font-poppins text-[#606060] block">
                Full Name <span className="text-[red]">*</span>
              </label>
            </div>
            <div className="flex gap-2">
              <select
                className="appearance-none w-[60px] border border-[#D2D2D2] px-2 py-1.5 rounded-sm text-[12px] text-[#606060] font-poppins"
                value={contact.title || ""}
                onChange={(e) =>
                  handleChange(["contactInfo", index, "title"], e.target.value)
                }
              >
                <option value="" disabled></option>
                {caseTitle.map((item, i) => (
                  <option key={`${item.value}-${i}`} value={item.value}>
                    {item.label}
                  </option>
                ))}
              </select>
              <input
                type="text"
                className="border border-[#D2D2D2] px-2 py-1 rounded-sm text-[12px] font-poppins flex-grow"
                value={hospitalData.contactInfo[index]?.firstName || ""}
                onChange={(e) =>
                  handleChange(
                    ["contactInfo", index, "firstName"],
                    e.target.value.charAt(0).toUpperCase() +
                      e.target.value.slice(1)
                  )
                }
                placeholder="First Name"
              />
            </div>
          </div>

          <div className="flex-1 min-w-[120px]">
            <label className="text-[13px] text-[#606060] block mb-1 font-poppins">
              Middle Name{" "}
              <span className="text-[10px] text-[#5B60A8]">(optional)</span>
            </label>
            <input
              type="text"
              className="border border-[#D2D2D2] px-2 py-1 rounded-sm text-[12px] font-poppins w-full"
              value={hospitalData.contactInfo[index]?.middleName || ""}
              onChange={(e) =>
                handleChange(
                  ["contactInfo", index, "middleName"],
                  e.target.value.charAt(0).toUpperCase() +
                    e.target.value.slice(1)
                )
              }
              placeholder="Middle Name"
            />
          </div>

          <div className="flex-1 min-w-[120px]">
            <label className="text-[13px] font-poppins text-[#606060] block mb-1">
              Last Name <span className="text-[red]">*</span>
            </label>
            <input
              type="text"
              className="border border-[#D2D2D2] px-2 py-1 rounded-sm text-[12px] font-poppins w-full"
              value={hospitalData.contactInfo[index]?.lastName || ""}
              onChange={(e) =>
                handleChange(
                  ["contactInfo", index, "lastName"],
                  e.target.value.charAt(0).toUpperCase() +
                    e.target.value.slice(1)
                )
              }
              placeholder="Last Name"
            />
          </div>

          <div className="flex-1 min-w-[160px]">
            <label className="text-[13px] font-poppins text-[#606060] block mb-1">
              Phone <span className="text-[red]">*</span>
            </label>
            <div className="flex">
              <select
                className="w-[60px] border border-[#D2D2D2] px-2 py-1 rounded-l-sm text-[12px] text-[#606060] font-poppins"
                value={contact.code || "+91"}
                onChange={(e) =>
                  handleChange(["contactInfo", index, "code"], e.target.value)
                }
              >
                {caseList.map((item, idx) => (
                  <option key={idx} value={item.value}>
                    {item.label}
                  </option>
                ))}
              </select>
              <input
                type="tel"
                className="border border-[#D2D2D2] px-2 py-1 rounded-r-sm text-[12px] font-poppins flex-grow"
                maxLength={10}
                value={contact.phone || ""}
                onChange={(e) => {
                  const value = e.target.value;
                  if (/^\d{0,10}$/.test(value)) {
                    handleChange(["contactInfo", index, "phone"], value);
                  }
                }}
                placeholder="Phone Number"
              />
            </div>
          </div>

          <div className="flex-1 min-w-[220px]">
            <label className="text-[13px] text-[#606060] block mb-1 font-poppins">
              Email <span className="text-[red]">*</span>
            </label>
            <input
              type="email"
              className="border border-[#D2D2D2] px-2 py-1 rounded-sm text-[12px] font-poppins w-full"
              value={contact.email || ""}
              onChange={(e) =>
                handleChange(["contactInfo", index, "email"], e.target.value)
              }
              placeholder="Email"
            />
          </div>
        </div>
      </div>
    </div>
  );

  return (
    <div>
      {loading ? (
        <Loader loading={loading} />
      ) : (
        <div className="p-2">
          <div className="bg-[#4951EC] text-white p-4 rounded-t-[10px] flex justify-between items-center">
            <div className="flex items-center gap-1">
              <MdAddHome size={22} />
              <h2 className="text-[14px] font-poppins">Edit Provider</h2>
            </div>
            <div className="flex gap-2">
              <button
                className="border hover:bg-blue-700 text-white font-poppins text-[14px] px-4 py-1 rounded-sm"
                onClick={EditSave}
              >
                Update
              </button>
              <button
                className="bg-[#fff] text-[#4951EC] text-[14px] font-poppins px-4 py-1 rounded-sm"
                onClick={() => {
                  if (window.confirm("Are you sure you want to go back?")) {
                    navigate("/hospital");
                  }
                }}
              >
                Back
              </button>
            </div>
          </div>

          <div className="bg-white overflow-y-auto h-[78vh] pb-[100px] p-4 rounded-b-[20px] shadow-lg">
            <h3 className="text-sm font-semibold mb-4 font-poppins text-[#3B3B3B]">
              Hospital General Information
            </h3>
            {hospitalData?.contactInfo?.map(renderContactForm)}
          </div>
        </div>
      )}
    </div>
  );
};

export default EditHospital;
